export default __webpack_public_path__ + "static/award-bg-5591ab54b8a4f272ad0cb0e8d7ef4c06.svg";